import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

/** Hamburger toggle button. Only rendered on mobile. */
export function MobileNavToggle({ open, onToggle }) {
  return (
    <button
      data-testid="nav-hamburger"
      onClick={onToggle}
      aria-label={open ? "Close menu" : "Open menu"}
      aria-expanded={open}
      className="md:hidden h-12 w-12 inline-flex items-center justify-center border-2 border-foreground dark:border-safety-yellow hover:bg-safety-yellow hover:text-black transition-colors flex-shrink-0"
    >
      {open ? <X className="w-5 h-5" strokeWidth={3} /> : <Menu className="w-5 h-5" strokeWidth={3} />}
    </button>
  );
}

/** Fullscreen mobile drawer + backdrop. Rendered when `open` is true. */
export function MobileNavPanel({ items, onClose }) {
  const loc = useLocation();
  return (
    <>
      <div
        className="md:hidden fixed inset-x-0 top-16 bottom-0 z-30 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <nav
        data-testid="nav-mobile-panel"
        className="md:hidden relative z-40 bg-background border-b-2 border-foreground dark:border-safety-yellow"
      >
        {items.map(({ to, label, Icon, testId }) => {
          const active = loc.pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              data-testid={`${testId}-mobile`}
              onClick={onClose}
              className={`min-h-[56px] w-full px-5 inline-flex items-center gap-3 text-base font-bold uppercase tracking-wider border-b-2 border-foreground/20 dark:border-safety-yellow/40 last:border-b-0 transition-colors ${
                active ? "bg-safety-yellow text-black" : "bg-transparent text-foreground hover:bg-safety-yellow/20"
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={2.5} />
              {label}
            </Link>
          );
        })}
      </nav>
    </>
  );
}
